var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPending(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.99967 2.33332V0.841651C6.99967 0.466651 6.54967 0.283318 6.29134 0.549985L3.95801 2.87498C3.79134 3.04165 3.79134 3.29998 3.95801 3.46665L6.28301 5.79165C6.54967 6.04998 6.99967 5.86665 6.99967 5.49165V3.99998C9.75801 3.99998 11.9997 6.24165 11.9997 8.99998C11.9997 9.65832 11.8747 10.3 11.633 10.875C11.508 11.175 11.5997 11.5167 11.8247 11.7417C12.2497 12.1667 12.9663 12.0167 13.1913 11.4583C13.4997 10.7 13.6663 9.86665 13.6663 8.99998C13.6663 5.31665 10.683 2.33332 6.99967 2.33332ZM6.99967 14C4.24134 14 1.99967 11.7583 1.99967 8.99998C1.99967 8.34165 2.12467 7.69998 2.36634 7.12498C2.49134 6.82498 2.39967 6.48332 2.17467 6.25832C1.74967 5.83332 1.03301 5.98332 0.808008 6.54165C0.499675 7.29998 0.333008 8.13332 0.333008 8.99998C0.333008 12.6833 3.31634 15.6667 6.99967 15.6667V17.1583C6.99967 17.5333 7.44967 17.7167 7.70801 17.45L10.033 15.125C10.1997 14.9583 10.1997 14.7 10.033 14.5333L7.70801 12.2083C7.44967 11.95 6.99967 12.1333 6.99967 12.5083V14Z",
    fill: "#3367CD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPending);
export default __webpack_public_path__ + "static/media/pending.c12dc405.svg";
export { ForwardRef as ReactComponent };